// src/features/statistics/lib/city-names.ts
// Маппинг строк городов Instagram API → страна (ISO) + русское название

export type CityInfo = {
  country: string; // ISO 3166-1 alpha-2
  nameRu: string;  // Русское отображаемое название
};

// Ключ — точная строка из Instagram API (format: "City, Region")
const CITY_MAP: Record<string, CityInfo> = {
  // ━━━━━━━━━ КАЗАХСТАН ━━━━━━━━━
  'Almaty, Almaty Region': { country: 'KZ', nameRu: 'Алматы' },
  'Alma-Ata, Almaty Region': { country: 'KZ', nameRu: 'Алматы' },
  'Astana, Akmola Region': { country: 'KZ', nameRu: 'Астана' },
  'Astana, Astana Region': { country: 'KZ', nameRu: 'Астана' },
  'Nur-Sultan, Akmola Region': { country: 'KZ', nameRu: 'Астана' },
  'Tselinograd, Akmola Region': { country: 'KZ', nameRu: 'Астана' },
  'Shymkent, Shymkent Region': { country: 'KZ', nameRu: 'Шымкент' },
  'Shymkent, South Kazakhstan Region': { country: 'KZ', nameRu: 'Шымкент' },
  'Karaganda, Karaganda Region': { country: 'KZ', nameRu: 'Қарағанды' },
  'Aktobe, Aktobe Region': { country: 'KZ', nameRu: 'Ақтөбе' },
  'Taraz, Zhambyl Region': { country: 'KZ', nameRu: 'Тараз' },
  'Pavlodar, Pavlodar Region': { country: 'KZ', nameRu: 'Павлодар' },
  'Ust-Kamenogorsk, East Kazakhstan Region': { country: 'KZ', nameRu: 'Өскемен' },
  'Semey, East Kazakhstan Region': { country: 'KZ', nameRu: 'Семей' },
  'Atyrau, Atyrau Region': { country: 'KZ', nameRu: 'Атырау' },
  'Aktau, Mangystau Region': { country: 'KZ', nameRu: 'Ақтау' },
  'Kyzylorda, Kyzylorda Region': { country: 'KZ', nameRu: 'Қызылорда' },
  'Uralsk, West Kazakhstan Region': { country: 'KZ', nameRu: 'Орал' },
  'Kostanay, Kostanay Region': { country: 'KZ', nameRu: 'Қостанай' },
  'Petropavlovsk, North Kazakhstan Region': { country: 'KZ', nameRu: 'Петропавл' },
  'Temirtau, Karaganda Region': { country: 'KZ', nameRu: 'Теміртау' },
  'Turkestan, Turkestan Region': { country: 'KZ', nameRu: 'Түркістан' },
  'Aksu, Pavlodar Region': { country: 'KZ', nameRu: 'Ақсу' },
  'Ekibastuz, Pavlodar Region': { country: 'KZ', nameRu: 'Екібастұз' },
  'Rudny, Kostanay Region': { country: 'KZ', nameRu: 'Рудный' },
  'Zhezkazgan, Karaganda Region': { country: 'KZ', nameRu: 'Жезқазған' },
  'Balkhash, Karaganda Region': { country: 'KZ', nameRu: 'Балқаш' },
  'Kentau, Turkestan Region': { country: 'KZ', nameRu: 'Кентау' },
  'Kapshagay, Almaty Region': { country: 'KZ', nameRu: 'Қапшағай' },
  'Taldykorgan, Zhetysu Region': { country: 'KZ', nameRu: 'Талдықорған' },
  'Satpayev, Karaganda Region': { country: 'KZ', nameRu: 'Сатпаев' },

  // ━━━━━━━━━ РОССИЯ ━━━━━━━━━
  'Moscow, Moscow': { country: 'RU', nameRu: 'Москва' },
  'Moscow, Moscow Oblast': { country: 'RU', nameRu: 'Москва' },
  "Saint Petersburg, St. Petersburg": { country: 'RU', nameRu: 'Санкт-Петербург' },
  'Saint Petersburg, Saint Petersburg': { country: 'RU', nameRu: 'Санкт-Петербург' },
  'Yekaterinburg, Sverdlovsk Oblast': { country: 'RU', nameRu: 'Екатеринбург' },
  'Novosibirsk, Novosibirsk Oblast': { country: 'RU', nameRu: 'Новосибирск' },
  'Kazan, Republic of Tatarstan': { country: 'RU', nameRu: 'Казань' },
  'Nizhny Novgorod, Nizhny Novgorod Oblast': { country: 'RU', nameRu: 'Нижний Новгород' },
  'Chelyabinsk, Chelyabinsk Oblast': { country: 'RU', nameRu: 'Челябинск' },
  'Samara, Samara Oblast': { country: 'RU', nameRu: 'Самара' },
  'Omsk, Omsk Oblast': { country: 'RU', nameRu: 'Омск' },
  'Rostov-on-Don, Rostov Oblast': { country: 'RU', nameRu: 'Ростов-на-Дону' },
  'Ufa, Republic of Bashkortostan': { country: 'RU', nameRu: 'Уфа' },
  'Krasnoyarsk, Krasnoyarsk Krai': { country: 'RU', nameRu: 'Красноярск' },
  'Perm, Perm Krai': { country: 'RU', nameRu: 'Пермь' },
  'Voronezh, Voronezh Oblast': { country: 'RU', nameRu: 'Воронеж' },
  'Volgograd, Volgograd Oblast': { country: 'RU', nameRu: 'Волгоград' },
  'Krasnodar, Krasnodar Krai': { country: 'RU', nameRu: 'Краснодар' },
  'Saratov, Saratov Oblast': { country: 'RU', nameRu: 'Саратов' },
  'Tyumen, Tyumen Oblast': { country: 'RU', nameRu: 'Тюмень' },
  'Tolyatti, Samara Oblast': { country: 'RU', nameRu: 'Тольятти' },
  'Izhevsk, Udmurtia': { country: 'RU', nameRu: 'Ижевск' },
  'Barnaul, Altai Krai': { country: 'RU', nameRu: 'Барнаул' },
  'Ulyanovsk, Ulyanovsk Oblast': { country: 'RU', nameRu: 'Ульяновск' },
  'Irkutsk, Irkutsk Oblast': { country: 'RU', nameRu: 'Иркутск' },
  'Khabarovsk, Khabarovsk Krai': { country: 'RU', nameRu: 'Хабаровск' },
  'Vladivostok, Primorsky Krai': { country: 'RU', nameRu: 'Владивосток' },
  'Makhachkala, Dagestan': { country: 'RU', nameRu: 'Махачкала' },
  'Novokuznetsk, Kemerovo Oblast': { country: 'RU', nameRu: 'Новокузнецк' },
  'Kemerovo, Kemerovo Oblast': { country: 'RU', nameRu: 'Кемерово' },
  'Ryazan, Ryazan Oblast': { country: 'RU', nameRu: 'Рязань' },
  'Astrakhan, Astrakhan Oblast': { country: 'RU', nameRu: 'Астрахань' },
  'Penza, Penza Oblast': { country: 'RU', nameRu: 'Пенза' },
  'Lipetsk, Lipetsk Oblast': { country: 'RU', nameRu: 'Липецк' },
  'Tula, Tula Oblast': { country: 'RU', nameRu: 'Тула' },
  'Kirov, Kirov Oblast': { country: 'RU', nameRu: 'Киров' },
  'Cheboksary, Chuvashia': { country: 'RU', nameRu: 'Чебоксары' },
  'Bryansk, Bryansk Oblast': { country: 'RU', nameRu: 'Брянск' },
  'Kursk, Kursk Oblast': { country: 'RU', nameRu: 'Курск' },
  'Magnitogorsk, Chelyabinsk Oblast': { country: 'RU', nameRu: 'Магнитогорск' },
  'Orenburg, Orenburg Oblast': { country: 'RU', nameRu: 'Оренбург' },
  'Sochi, Krasnodar Krai': { country: 'RU', nameRu: 'Сочи' },
  'Tomsk, Tomsk Oblast': { country: 'RU', nameRu: 'Томск' },
  'Yakutsk, Sakha Republic': { country: 'RU', nameRu: 'Якутск' },

  // ━━━━━━━━━ УЗБЕКИСТАН ━━━━━━━━━
  'Tashkent, Tashkent Region': { country: 'UZ', nameRu: 'Ташкент' },
  'Tashkent, Tashkent': { country: 'UZ', nameRu: 'Ташкент' },
  'Samarkand, Samarkand Region': { country: 'UZ', nameRu: 'Самарканд' },
  'Namangan, Namangan Region': { country: 'UZ', nameRu: 'Наманган' },
  'Andijan, Andijan Region': { country: 'UZ', nameRu: 'Андижан' },
  'Fergana, Fergana Region': { country: 'UZ', nameRu: 'Фергана' },
  'Bukhara, Bukhara Region': { country: 'UZ', nameRu: 'Бухара' },
  'Nukus, Karakalpakstan': { country: 'UZ', nameRu: 'Нукус' },
  'Karshi, Kashkadarya Region': { country: 'UZ', nameRu: 'Карши' },
  'Kokand, Fergana Region': { country: 'UZ', nameRu: 'Коканд' },
  'Margilan, Fergana Region': { country: 'UZ', nameRu: 'Маргилан' },
  'Navoi, Navoi Region': { country: 'UZ', nameRu: 'Навои' },

  // ━━━━━━━━━ КЫРГЫЗСТАН ━━━━━━━━━
  'Bishkek, Chuy Region': { country: 'KG', nameRu: 'Бишкек' },
  'Bishkek, Bishkek': { country: 'KG', nameRu: 'Бишкек' },
  'Osh, Osh Region': { country: 'KG', nameRu: 'Ош' },
  'Osh, Osh': { country: 'KG', nameRu: 'Ош' },
  'Jalal-Abad, Jalal-Abad Region': { country: 'KG', nameRu: 'Жалал-Абад' },
  'Karakol, Issyk-Kul Region': { country: 'KG', nameRu: 'Каракол' },

  // ━━━━━━━━━ АЗЕРБАЙДЖАН ━━━━━━━━━
  'Baku, Baku': { country: 'AZ', nameRu: 'Баку' },
  'Baku, Absheron District': { country: 'AZ', nameRu: 'Баку' },
  'Ganja, Ganja': { country: 'AZ', nameRu: 'Гянджа' },
  'Sumqayit, Sumqayit': { country: 'AZ', nameRu: 'Сумгайыт' },

  // ━━━━━━━━━ АРМЕНИЯ ━━━━━━━━━
  'Yerevan, Yerevan': { country: 'AM', nameRu: 'Ереван' },
  'Gyumri, Shirak Province': { country: 'AM', nameRu: 'Гюмри' },

  // ━━━━━━━━━ ГРУЗИЯ ━━━━━━━━━
  'Tbilisi, Tbilisi': { country: 'GE', nameRu: 'Тбилиси' },
  'Batumi, Adjara': { country: 'GE', nameRu: 'Батуми' },
  'Kutaisi, Imereti': { country: 'GE', nameRu: 'Кутаиси' },

  // ━━━━━━━━━ БЕЛАРУСЬ ━━━━━━━━━
  'Minsk, Minsk': { country: 'BY', nameRu: 'Минск' },
  'Minsk, Minsk Region': { country: 'BY', nameRu: 'Минск' },
  'Gomel, Gomel Region': { country: 'BY', nameRu: 'Гомель' },
  'Vitebsk, Vitebsk Region': { country: 'BY', nameRu: 'Витебск' },

  // ━━━━━━━━━ УКРАИНА ━━━━━━━━━
  'Kyiv, Kyiv City': { country: 'UA', nameRu: 'Киев' },
  'Kiev, Kyiv City': { country: 'UA', nameRu: 'Киев' },
  'Kharkiv, Kharkiv Oblast': { country: 'UA', nameRu: 'Харьков' },
  'Odessa, Odessa Oblast': { country: 'UA', nameRu: 'Одесса' },
  'Dnipro, Dnipropetrovsk Oblast': { country: 'UA', nameRu: 'Днепр' },
  'Lviv, Lviv Oblast': { country: 'UA', nameRu: 'Львов' },

  // ━━━━━━━━━ ТАДЖИКИСТАН ━━━━━━━━━
  'Dushanbe, Dushanbe': { country: 'TJ', nameRu: 'Душанбе' },
  'Khujand, Sughd Province': { country: 'TJ', nameRu: 'Худжанд' },

  // ━━━━━━━━━ ТУРКМЕНИСТАН ━━━━━━━━━
  'Ashgabat, Ashgabat': { country: 'TM', nameRu: 'Ашхабад' },

  // ━━━━━━━━━ ОАЭ ━━━━━━━━━
  'Dubai, Dubai': { country: 'AE', nameRu: 'Дубай' },
  'Abu Dhabi, Abu Dhabi': { country: 'AE', nameRu: 'Абу-Даби' },
  'Sharjah, Sharjah': { country: 'AE', nameRu: 'Шарджа' },

  // ━━━━━━━━━ ТУРЦИЯ ━━━━━━━━━
  'Istanbul, Istanbul': { country: 'TR', nameRu: 'Стамбул' },
  'Ankara, Ankara': { country: 'TR', nameRu: 'Анкара' },
  'Izmir, Izmir': { country: 'TR', nameRu: 'Измир' },
  'Antalya, Antalya': { country: 'TR', nameRu: 'Анталья' },
  'Bursa, Bursa': { country: 'TR', nameRu: 'Бурса' },

  // ━━━━━━━━━ ГЕРМАНИЯ ━━━━━━━━━
  'Berlin, Berlin': { country: 'DE', nameRu: 'Берлин' },
  'Frankfurt, Hesse': { country: 'DE', nameRu: 'Франкфурт' },
  'Munich, Bavaria': { country: 'DE', nameRu: 'Мюнхен' },
  'Hamburg, Hamburg': { country: 'DE', nameRu: 'Гамбург' },

  // ━━━━━━━━━ США ━━━━━━━━━
  'New York, New York': { country: 'US', nameRu: 'Нью-Йорк' },
  'Los Angeles, California': { country: 'US', nameRu: 'Лос-Анджелес' },
  'Chicago, Illinois': { country: 'US', nameRu: 'Чикаго' },
  'Houston, Texas': { country: 'US', nameRu: 'Хьюстон' },
  'Phoenix, Arizona': { country: 'US', nameRu: 'Финикс' },

  // ━━━━━━━━━ ВЕЛИКОБРИТАНИЯ ━━━━━━━━━
  'London, England': { country: 'GB', nameRu: 'Лондон' },
  'Manchester, England': { country: 'GB', nameRu: 'Манчестер' },
  'Birmingham, England': { country: 'GB', nameRu: 'Бирмингем' },

  // ━━━━━━━━━ САУДОВСКАЯ АРАВИЯ ━━━━━━━━━
  'Riyadh, Riyadh Region': { country: 'SA', nameRu: 'Эр-Рияд' },
  'Jeddah, Makkah Region': { country: 'SA', nameRu: 'Джидда' },
  'Mecca, Makkah Region': { country: 'SA', nameRu: 'Мекка' },

  // ━━━━━━━━━ ИРАН ━━━━━━━━━
  'Tehran, Tehran Province': { country: 'IR', nameRu: 'Тегеран' },
  'Isfahan, Isfahan Province': { country: 'IR', nameRu: 'Исфахан' },

  // ━━━━━━━━━ ПАКИСТАН ━━━━━━━━━
  'Karachi, Sindh': { country: 'PK', nameRu: 'Карачи' },
  'Lahore, Punjab': { country: 'PK', nameRu: 'Лахор' },
  'Islamabad, Islamabad Capital Territory': { country: 'PK', nameRu: 'Исламабад' },

  // ━━━━━━━━━ ИНДИЯ ━━━━━━━━━
  'Mumbai, Maharashtra': { country: 'IN', nameRu: 'Мумбаи' },
  'Delhi, National Capital Territory of Delhi': { country: 'IN', nameRu: 'Дели' },
  'Bangalore, Karnataka': { country: 'IN', nameRu: 'Бангалор' },

  // ━━━━━━━━━ КИТАЙ ━━━━━━━━━
  'Beijing, Beijing': { country: 'CN', nameRu: 'Пекин' },
  'Shanghai, Shanghai': { country: 'CN', nameRu: 'Шанхай' },

  // ━━━━━━━━━ ФРАНЦИЯ ━━━━━━━━━
  'Paris, Ile-de-France': { country: 'FR', nameRu: 'Париж' },

  // ━━━━━━━━━ ИТАЛИЯ ━━━━━━━━━
  'Rome, Latium': { country: 'IT', nameRu: 'Рим' },
  'Milan, Lombardy': { country: 'IT', nameRu: 'Милан' },

  // ━━━━━━━━━ ИСПАНИЯ ━━━━━━━━━
  'Madrid, Community of Madrid': { country: 'ES', nameRu: 'Мадрид' },
  'Barcelona, Catalonia': { country: 'ES', nameRu: 'Барселона' },

  // ━━━━━━━━━ ПОЛЬША ━━━━━━━━━
  'Warsaw, Masovian Voivodeship': { country: 'PL', nameRu: 'Варшава' },
  'Krakow, Lesser Poland Voivodeship': { country: 'PL', nameRu: 'Краков' },

  // ━━━━━━━━━ НИДЕРЛАНДЫ ━━━━━━━━━
  'Amsterdam, North Holland': { country: 'NL', nameRu: 'Амстердам' },

  // ━━━━━━━━━ ИЗРАИЛЬ ━━━━━━━━━
  'Tel Aviv, Tel Aviv District': { country: 'IL', nameRu: 'Тель-Авив' },

  // ━━━━━━━━━ ЕГИПЕТ ━━━━━━━━━
  'Cairo, Cairo Governorate': { country: 'EG', nameRu: 'Каир' },
  'Alexandria, Alexandria Governorate': { country: 'EG', nameRu: 'Александрия' },

  // ━━━━━━━━━ НИГЕРИЯ ━━━━━━━━━
  'Lagos, Lagos State': { country: 'NG', nameRu: 'Лагос' },
  'Abuja, Federal Capital Territory': { country: 'NG', nameRu: 'Абуджа' },

  // ━━━━━━━━━ БРАЗИЛИЯ ━━━━━━━━━
  'Sao Paulo, Sao Paulo': { country: 'BR', nameRu: 'Сан-Паулу' },
  'Rio de Janeiro, Rio de Janeiro': { country: 'BR', nameRu: 'Рио-де-Жанейро' },

  // ━━━━━━━━━ МЕКСИКА ━━━━━━━━━
  'Mexico City, Federal District': { country: 'MX', nameRu: 'Мехико' },

  // ━━━━━━━━━ АРГЕНТИНА ━━━━━━━━━
  'Buenos Aires, Buenos Aires F.D.': { country: 'AR', nameRu: 'Буэнос-Айрес' },

  // ━━━━━━━━━ КАНАДА ━━━━━━━━━
  'Toronto, Ontario': { country: 'CA', nameRu: 'Торонто' },
  'Vancouver, British Columbia': { country: 'CA', nameRu: 'Ванкувер' },

  // ━━━━━━━━━ АВСТРАЛИЯ ━━━━━━━━━
  'Sydney, New South Wales': { country: 'AU', nameRu: 'Сидней' },
  'Melbourne, Victoria': { country: 'AU', nameRu: 'Мельбурн' },

  // ━━━━━━━━━ ЯПОНИЯ ━━━━━━━━━
  'Tokyo, Tokyo': { country: 'JP', nameRu: 'Токио' },
  'Osaka, Osaka': { country: 'JP', nameRu: 'Осака' },

  // ━━━━━━━━━ ЮЖНАЯ КОРЕЯ ━━━━━━━━━
  'Seoul, Seoul': { country: 'KR', nameRu: 'Сеул' },

  // ━━━━━━━━━ СИНГАПУР ━━━━━━━━━
  'Singapore, Central Region': { country: 'SG', nameRu: 'Сингапур' },
  'Singapore, Singapore': { country: 'SG', nameRu: 'Сингапур' },

  // ━━━━━━━━━ МАЛАЙЗИЯ ━━━━━━━━━
  'Kuala Lumpur, Federal Territory of Kuala Lumpur': { country: 'MY', nameRu: 'Куала-Лумпур' },

  // ━━━━━━━━━ ИНДОНЕЗИЯ ━━━━━━━━━
  'Jakarta, Jakarta': { country: 'ID', nameRu: 'Джакарта' },

  // ━━━━━━━━━ ТАИЛАНД ━━━━━━━━━
  'Bangkok, Bangkok': { country: 'TH', nameRu: 'Бангкок' },

  // ━━━━━━━━━ ВЬЕТНАМ ━━━━━━━━━
  'Ho Chi Minh City, Ho Chi Minh City': { country: 'VN', nameRu: 'Хошимин' },
  'Hanoi, Hanoi': { country: 'VN', nameRu: 'Ханой' },
};

/**
 * Возвращает информацию о городе по строке Instagram API.
 * Если не найден — возвращает null.
 */
export function getCityInfo(cityApiString: string): CityInfo | null {
  return CITY_MAP[cityApiString] ?? null;
}

/**
 * Русское отображаемое название города.
 * Если нет в маппинге — возвращает первую часть строки до запятой.
 */
export function getCityDisplayName(cityApiString: string): string {
  const info = CITY_MAP[cityApiString];
  if (info) return info.nameRu;
  // Fallback: берём первую часть "City, Region" → "City"
  return cityApiString.split(',')[0].trim();
}

/**
 * Группирует список городов (API-строк) по странам.
 * Города с неизвестной страной попадают в группу '__other__'.
 */
export function groupCitiesByCountry(
  cities: string[]
): Array<{ country: string; cities: Array<{ api: string; nameRu: string }> }> {
  const grouped = new Map<string, Array<{ api: string; nameRu: string }>>();

  for (const city of cities) {
    const info = CITY_MAP[city];
    const countryKey = info?.country ?? '__other__';
    const nameRu = info?.nameRu ?? city.split(',')[0].trim();

    if (!grouped.has(countryKey)) grouped.set(countryKey, []);
    grouped.get(countryKey)!.push({ api: city, nameRu });
  }

  // Сортируем города внутри каждой группы по русскому названию
  for (const arr of grouped.values()) {
    arr.sort((a, b) => a.nameRu.localeCompare(b.nameRu, 'ru'));
  }

  // Возвращаем список групп, '__other__' в конце
  const result: Array<{ country: string; cities: Array<{ api: string; nameRu: string }> }> = [];
  for (const [country, citiesArr] of grouped) {
    if (country !== '__other__') result.push({ country, cities: citiesArr });
  }
  result.sort((a, b) => a.country.localeCompare(b.country));

  const other = grouped.get('__other__');
  if (other && other.length > 0) result.push({ country: '__other__', cities: other });

  return result;
}
